export const SESSION_STORAGE_VARIABLES = {
  PURCHASED_PRODUCT_TYPE_ID: 'purchasedProductTypeId',
  DISMISSED_ALERTS: 'dismissedAlerts',
  CHANGE_PLAN_SUCCESS: 'changePlanSuccess',
  SHOW_PLAN_TAB: 'showPlanTab',
  DIAGNOSTIC_RUNS_TIMESTAMPS: 'diagnosticRunsTimestamps',
  CIF_ORDER_SUCCESS: 'cancelInFlightOrderSuccess',
};
